import { GroupEnvironment } from 'models/environment';
import { Point } from 'models/point';
import { getLocal, saveLocal } from '../util/localStore';

export const environments: GroupEnvironment = {
  local: {
    center: { lat: 4.705919, lng: -74.066528 },
    microServices: {
      api: 'https://microservices.dev.rappi.com/api/operation-management/',
      internalApi: 'https://microservices.dev.rappi.com/',
      grappiApi: 'https://microservices.dev.rappi.com/api/grappi-api/'
    },
    timeZone: 'America/Bogota',
    iso: 'co',
    redirect: 'http://localhost:4200/callback',
    currency: 'cop'
  },
  dev: {
    center: { lat: 4.705919, lng: -74.066528 },
    microServices: {
      api: 'https://microservices.dev.rappi.com/api/operation-management/',
      internalApi: 'https://microservices.dev.rappi.com/',
      grappiApi: 'https://microservices.dev.rappi.com/api/grappi-api/'
    },
    timeZone: 'America/Bogota',
    iso: 'co',
    redirect: 'https://operation-management-app.dev.rappi.com/callback',
    currency: 'cop'
  },
  co: {
    center: { lat: 4.705919, lng: -74.066528 },
    microServices: {
      api: 'https://services.rappi.com/api/operation-management/',
      internalApi: 'https://services.rappi.com/',
      grappiApi: 'https://services.rappi.com/api/grappi-api/'
    },
    timeZone: 'America/Bogota',
    iso: 'co',
    redirect: 'https://operation-management-app.rappi.com.co/callback',
    currency: 'cop'
  },
  pe: {
    center: { lat: -16.409046, lng: -71.537453 },
    microServices: {
      api: 'https://services.rappi.pe/api/operation-management/',
      internalApi: 'https://services.rappi.pe/',
      grappiApi: 'https://services.rappi.pe/api/grappi-api/'
    },
    timeZone: 'America/Lima',
    iso: 'pe',
    redirect: 'https://operation-management-app.rappi.com.pe/callback',
    currency: 'pen'
  },
  ar: {
    center: { lat: -34.6, lng: -58.38 },
    microServices: {
      api: 'https://services.rappi.com.ar/api/operation-management/',
      internalApi: 'https://services.rappi.com.ar/',
      grappiApi: 'https://services.rappi.com.ar/api/grappi-api/'
    },
    timeZone: 'America/Argentina/Buenos_Aires',
    iso: 'ar',
    redirect: 'https://operation-management-app.rappi.com.ar/callback',
    currency: 'ars'
  },
  br: {
    center: { lat: -23.561058, lng: -46.5790097 },
    microServices: {
      api: 'https://services.rappi.com.br/api/operation-management/',
      internalApi: 'https://services.rappi.com.br/',
      grappiApi: 'https://services.rappi.com.br/api/grappi-api/'
    },
    timeZone: 'America/Sao_Paulo',
    iso: 'br',
    redirect: 'https://operation-management-app.rappi.com.br/callback',
    currency: 'brl'
  },
  uy: {
    center: { lat: -34.83, lng: -56.22 },
    microServices: {
      api: 'https://services.rappi.com.uy/api/operation-management/',
      internalApi: 'https://services.rappi.com.uy/',
      grappiApi: 'https://services.rappi.com.uy/api/grappi-api/'
    },
    timeZone: 'America/Montevideo',
    iso: 'uy',
    redirect: 'https://operation-management-app.rappi.com.uy/callback',
    currency: 'uyu'
  },
  mx: {
    center: { lat: 19.43, lng: -99.13 },
    microServices: {
      api: 'https://services.mxgrability.rappi.com/api/operation-management/',
      internalApi: 'https://services.mxgrability.rappi.com/',
      grappiApi: 'https://services.mxgrability.rappi.com/api/grappi-api/'
    },
    timeZone: 'America/Mexico_City',
    iso: 'mx',
    redirect: 'https://operation-management-app.rappi.com.mx/callback',
    currency: 'mxn'
  },
  cl: {
    center: { lat: -33.45, lng: -70.67 },
    microServices: {
      api: 'https://services.rappi.cl/api/operation-management/',
      internalApi: 'https://services.rappi.cl/',
      grappiApi: 'https://services.rappi.cl/api/grappi-api/'
    },
    timeZone: 'America/Santiago',
    iso: 'cl',
    redirect: 'https://operation-management-app.rappi.cl/callback',
    currency: 'clp'
  },
  cr: {
    center: { lat: 9.9281, lng: -84.0907 },
    microServices: {
      api: 'https://services.rappi.co.cr/api/operation-management/',
      internalApi: 'https://services.rappi.co.cr/',
      grappiApi: 'https://services.rappi.co.cr/api/grappi-api/'
    },
    timeZone: 'America/Costa_Rica',
    iso: 'cr',
    redirect: 'https://operation-management-app.rappi.co.cr/callback',
    currency: 'crc'
  },
  ec: {
    center: { lat: -0.1807, lng: -78.4678 },
    microServices: {
      api: 'https://services.rappi.com.ec/api/operation-management/',
      internalApi: 'https://services.rappi.com.ec/',
      grappiApi: 'https://services.rappi.com.ec/api/grappi-api/'
    },
    timeZone: 'America/Guayaquil',
    iso: 'ec',
    redirect: 'https://operation-management-app.rappi.com.ec/callback',
    currency: 'usd'
  }
};

export let envStr: string = process.env.REACT_APP_ENV
  ? (process.env.REACT_APP_ENV as string)
  : 'dev';
envStr = envStr.trim();

export const getIso = () => {
  return envStr ? environments[envStr].iso : undefined;
};

export const getTimeZone = () => {
  return environments[envStr].timeZone;
};

export const getCountry = () => {
  return getLocal('current_country');
};

export const getRealCountry = () => {
  return isDevMode ? 'dev' : envStr;
};

export const setCountry = (country: string) => {
  saveLocal('current_country', country, 0);
};

export const getUrl = (iso) => {
  return environments[iso].redirect;
};

export const getEnvCenter = () => {
  return envStr
    ? environments[envStr].center
    : ({ lat: 4.705919, lng: -74.066528 } as Point);
};

export const isDevMode = envStr === 'dev';
export const isLocal = envStr === 'local';
export const gtmID = 'GTM-WC3JHLT';

export const lupeUrls = () =>
  isDevMode || isLocal
    ? {
        sk: 'https://lupe.dev.rappi.com/sk-profile/home',
        od: 'https://lupe.dev.rappi.com/support/search-orders'
      }
    : {
        sk: 'https://lupe.rappi.com/sk-profile/home',
        od: 'https://lupe.rappi.com/support/search-orders'
      };

export default environments[envStr || 'local'];
